import React from 'react';
import './styles.scss';

const Header = React.memo(({ children }) => {
    return <div className="fm-header">{children}</div>;
});

export default Header;
